module.exports = __webpack_public_path__ + "static/media/add_to_queue.2fbe3f25.svg";